const colors = {
  red: '#EF564A',
  pink: '#fcbec3',
  orange: '#f5af76',
  green: '#5acc7d',
  gray: '#bababa',
  blue: '#1755c5',
  lightblue: '#5E9BDB',
};

const raceCandidateColors = {
  'us-senate-class-2-Republican': [
    {
      name: 'Ken Paxton',
      color: colors.pink,
    },
    {
      name: 'John Cornyn',
      color: colors.red,
    },
  ],
  'attorney-general-Democrat': [
    {
      name: 'Nathan Johnson',
      color: colors.lightblue,
    },
    {
      name: 'Joe Jaworski',
      color: colors.blue,
    },
  ],
  'attorney-general-Republican': [
    {
      name: 'Chip Roy',
      color: colors.pink,
    },
    {
      name: 'Mayes Middleton',
      color: colors.red,
    },
  ],
  'comptroller-Republican': [
    {
      name: 'Kelly Hancock',
      color: colors.red,
    },
    {
      name: 'Michael Berlanga',
      color: colors.gray,
    },
    {
      name: 'Christi Craddick',
      color: colors.orange,
    },
    {
      name: 'Don Huffines',
      color: colors.pink,
    },
  ],
};

export default raceCandidateColors;
